import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ad5920a2")

_pushScopeId("data-v-ad5920a2")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "logo" }, "Sparing Timer", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: "/img/btn_google_signin_light_normal_web@2x.png",
  alt: "Sign in with Google",
  class: "login-img"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("a", {
        class: "login-btn",
        href: _ctx.googleAuthUrl
      }, [
        _hoisted_4
      ], 8, ["href"])
    ])
  ]))
})